import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { SecurityRepository } from "@/app/security/repositories/SecurityRepository";
import { LoginModel, SecurityModel } from "@/app/security/models/SecurityModel";

export function loginController() {
  const repository: SecurityRepository = new SecurityRepository(new HttpClientService());

  return useRequest<LoginModel>({
    fn: async (securityModel: SecurityModel) => await repository.login(securityModel),
    modelClass: LoginModel,
  });
}
